export default __webpack_public_path__ + "static/media/SD-pooja-times-img.220a5cc0.png";